import { render, staticRenderFns } from "./global-vars.vue?vue&type=template&id=87fa6980&"
import script from "./global-vars.vue?vue&type=script&lang=js&"
export * from "./global-vars.vue?vue&type=script&lang=js&"
import style0 from "./global-vars.vue?vue&type=style&index=0&id=87fa6980&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports